import React, { FC } from 'react'
import { Box, Button, Divider, Grid, GridItem, Text } from '@chakra-ui/react'
import { useColor } from '../../theme'
import { SHARED_TEMPLATE_COLUMNS } from './SectionListItem'

interface IWithAction {
  action: string
  isDisabled?: boolean
  onClick: () => void
}

interface IItemProps {
  title: string
  withAction?: IWithAction
  children?: React.ReactNode,
  'data-testid'?: string
}

/**
 * Simple section list item.
 *
 * Should be combined with the `SectionList` component.
 */
export const SectionSimpleListItem: FC<IItemProps> = ({
  children,
  title,
  withAction,
}) => {
  const dividerColor = useColor({
    nuance: 1,
    palette: 'secondary',
  })

  const titleColor = useColor({
    nuance: 3,
    palette: 'text',
  })

  return (
    <Box data-testid="section-simple-list-item-container">
      <Grid
        columnGap={4}
        paddingY={4}
        templateColumns={SHARED_TEMPLATE_COLUMNS}
        templateRows="repeat(1fr, 2)"
        width="full">
        <GridItem paddingTop={2}>
          <Text color={titleColor} fontSize="sm">
            {title}
          </Text>
        </GridItem>
        <GridItem
          paddingTop={2}
          {...(withAction ? {} : { gridColumn: 'span 2' })}>
          {children}
        </GridItem>
        {withAction && (
          <GridItem>
            <Button
              _disabled={{ color: 'inherit', cursor: 'not-allowed' }}
              _hover={{ backgroundColor: 'inherit' }}
              data-testid="section-simple-list-item-action"
              fontSize="md"
              isDisabled={withAction.isDisabled}
              onClick={withAction.onClick}
              paddingRight="1.5rem"
              size="sm"
              textAlign="end"
              variant="tertiary"
              width="full">
              {withAction.action}
            </Button>
          </GridItem>
        )}
      </Grid>
      <Divider borderColor={dividerColor} opacity={1} />
    </Box>
  )
}
